// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","content":"Footer_content__aJpHx","link":"Footer_link__3Ie8d","sponsor":"Footer_sponsor__y2DEd","sponsorIcon":"Footer_sponsorIcon__DmYk+"};